module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "tg"
  }, [_c('tr', [_c('th', {
    staticClass: "tg-yw4l"
  }, [_vm._v("Stage")]), _vm._v(" "), _c('th', {
    staticClass: "tg-yw4l",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Criteria")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-031e"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "tg-yw4l",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Laboratory criteria met for acute HIV infection, or"), _c('br'), _vm._v("previous negative or indeterminate HIV test within"), _c('br'), _vm._v("180 days of first confirmed positive HIV test.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "tg-031e",
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("Stage 0"), _c('br'), _vm._v("not met "), _c('i', {
    staticStyle: {
      "position": "relative",
      "left": "30px",
      "top": "-10px"
    }
  }, [_vm._v("and")])]), _vm._v(" "), _c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("CD4 ≥500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("2a")]), _vm._v(" "), _c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("CD4 350–499")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("2b")]), _vm._v(" "), _c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("CD4 200–349")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("CD4 <200")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("Unknown")]), _vm._v(" "), _c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("No available CD4")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a9d935f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/web/components/Table1.vue
// module id = 130
// module chunks = 0